class Popup {
  constructor(container) {
    this.button = null;
    this.popup = null;
    this.showButtons = null;
    this.container = container;
    this.elements = this.cacheElements();
    this.closeEventName = 'brand_venues_close_popup';
    this.openEventName = 'brand_venues_open_popup';

    this.init();
  }

  // eslint-disable-next-line class-methods-use-this
  cacheElements() {
    return {};
  }

  addCloseButtons() {
    if (this.elements.popup) {
      this.elements.closeButtons = this.elements.popup.querySelectorAll('.brand-venues__action-close');
    } else {
      this.elements.closeButtons = [];
    }
  }

  init() {
    this.addCloseButtons();

    this.elements.popup?.removeAttribute('style');
    this.elements?.closeButtons?.forEach((button) => {
      button.addEventListener('click', (e) => {
        this.closePopup(e, button);
      });
    });

    this.elements.showButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        if (button.classList.contains('brand-venues__action-card') && !button.hasAttribute('data-action-type')) {
          return;
        }
        this.showPopup(e, button);
      });
    });

    if (this.elements.popup) {
      this.elements.popup.addEventListener('keydown', (e) => {
        this.handleFocusTrap(e);
      });
      this.elements.popup.addEventListener('cancel', (e) => {
        this.handleDialogCancel(e);
      });
    }
  }

  handleFocusTrap(event) {
    if (event.key !== 'Tab') return;

    const focusableElements = this.elements.popup.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );

    const focusableArray = Array
      .from(focusableElements)
      .filter((el) => el.offsetParent !== null && el.tabIndex !== -1);

    if (focusableArray.length === 0) return;

    const firstFocusable = focusableArray[0];
    const lastFocusable = focusableArray[focusableArray.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else if (document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  }

  handleDialogCancel(event) {
    event.preventDefault();
    this.closePopup(event, this.elements.popup);
  }

  closePopup(event, button) {
    event.preventDefault();
    const popup = button.closest('.brand-venues__popup');
    popup.style.opacity = 0;

    this.elements.popup.classList.remove('brand-venues__popup-backdrop--visible');

    setTimeout(() => {
      // Use native dialog close method for proper transition
      popup.close();
      popup.style.opacity = 1;

      // Restore scroll after animation completes
      Popup.unlockWindow();
    }, 500);

    // eslint-disable-next-line no-new
    const closeEvent = new CustomEvent(this.closeEventName, {
      detail: {
        parentEvent: event,
      },
    });

    document.dispatchEvent(closeEvent, {
      details: {
        button,
      },
    });
  }

  showPopup(e, button) {
    e.preventDefault();
    this.button = e.target;

    Popup.lockWindow();
    this.elements.popup.inert = true;
    this.elements.popup.showModal();
    this.elements.popup.inert = false;

    this.elements.popup.classList.add('brand-venues__popup-backdrop--visible');

    setTimeout(() => {
      const closeButton = this.elements.popup.querySelector('.brand-venues__action-close');
      if (closeButton) {
        closeButton.focus();
      }
    }, 100);

    // eslint-disable-next-line no-new
    const showEvent = new CustomEvent(this.openEventName, {
      detail: {
        parentEvent: e,
        clickedButton: button,
      },
    });

    document.dispatchEvent(showEvent);
  }

  static lockWindow() {
    const { scrollY } = window;
    document.body.dataset.scrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
  }

  static unlockWindow() {
    const savedScroll = document.body.dataset.scrollY;
    const scrollY = Number.isNaN(parseInt(savedScroll, 10))
      ? window.scrollY : parseInt(savedScroll, 10);

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    delete document.body.dataset.scrollY;

    window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
  }
}

export default Popup;
